import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { formatData } from '../utils';
import { useCardan } from '@magalu/mixer-graphql';
import { ACTIONS, ENTITIES } from '../constants';
var cardanDataService = function cardanDataService(state, dispatch) {
  var _useCardan = useCardan(),
    fetchCompatibilityDataHook = _useCardan.fetchCompatibilityDataHook,
    fetchVehicleDataHook = _useCardan.fetchVehicleDataHook,
    fetchPlateDataHook = _useCardan.fetchPlateDataHook;
  var processResponseData = function processResponseData(data) {
    var dataProcessors = [{
      entity: ENTITIES.BRANDS,
      format: function format(items) {
        return formatData(items, 'name', ['urlLogo']);
      },
      key: 'vehicleBrands'
    }, {
      entity: ENTITIES.MODELS,
      format: function format(items) {
        return formatData(items);
      },
      key: 'vehicleModels'
    }, {
      entity: ENTITIES.YEARS,
      format: function format(items) {
        return formatData(items, 'year');
      },
      key: 'vehicleYears'
    }, {
      entity: ENTITIES.VERSIONS,
      format: function format(items) {
        return formatData(items);
      },
      key: 'vehicleVersions'
    }];
    dataProcessors.forEach(function (_ref) {
      var key = _ref.key,
        entity = _ref.entity,
        format = _ref.format;
      if (data[key]) {
        var formattedData = format(data[key]);
        dispatch({
          entity: entity,
          payload: formattedData,
          type: ACTIONS.SET_DATA
        });
      }
    });
  };
  var processPlateData = function processPlateData(data) {
    var _state$data, _global, _global$window, _global$window$locati;
    dispatch({
      payload: data.plate,
      type: ACTIONS.SET_CAR_PLATE
    });
    var brands = state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data[ENTITIES.BRANDS];
    var selectedBrandObj = brands.find(function (brand) {
      return String(brand == null ? void 0 : brand.name) === String(data.brand);
    });
    dispatch({
      payload: {
        id: data.brand,
        urlLogo: selectedBrandObj == null ? void 0 : selectedBrandObj.urlLogo
      },
      type: ACTIONS.CHANGE_BRAND
    });
    dispatch({
      payload: String(data.model),
      type: ACTIONS.CHANGE_MODEL
    });
    dispatch({
      payload: String(data.year),
      type: ACTIONS.CHANGE_YEAR
    });
    dispatch({
      payload: String(data.version),
      type: ACTIONS.CHANGE_VERSION
    });
    var vehicleDetails = "".concat(data.brand, " ").concat(data.model, " ").concat(data.year, " ").concat(data.version);
    dispatch({
      payload: vehicleDetails,
      type: ACTIONS.SET_VEHICLE_DETAILS
    });
    dispatch({
      payload: (_global = global) == null ? void 0 : (_global$window = _global.window) == null ? void 0 : (_global$window$locati = _global$window.location) == null ? void 0 : _global$window$locati.pathname,
      type: ACTIONS.SAVE_SEARCH_URL
    });
  };
  var fetchCompatibilityDataService = function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(partnumber) {
      var _data$compatibility, compatibilityParams, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: ACTIONS.FETCH_START
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR
            });
            _context.prev = 2;
            compatibilityParams = _extends({}, state.selected || {}, {
              partNumber: String(partnumber || '')
            });
            _context.next = 6;
            return fetchCompatibilityDataHook(compatibilityParams);
          case 6:
            data = _context.sent;
            if (data) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", null);
          case 9:
            dispatch({
              payload: data == null ? void 0 : (_data$compatibility = data.compatibility) == null ? void 0 : _data$compatibility.compatible,
              type: ACTIONS.SET_COMPATIBILITY
            });
            return _context.abrupt("return", data);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            dispatch({
              payload: _context.t0.message || 'Unknown error occurred',
              type: ACTIONS.SET_ERROR
            });
            return _context.abrupt("return", null);
          case 17:
            _context.prev = 17;
            dispatch({
              type: ACTIONS.FETCH_END
            });
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13, 17, 20]]);
    }));
    return function fetchCompatibilityDataService(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetchVehicleDataService = function () {
    var _ref3 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: ACTIONS.FETCH_START
            });
            dispatch({
              payload: true,
              type: ACTIONS.SET_LOADING
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR
            });
            _context2.prev = 3;
            _context2.next = 6;
            return fetchVehicleDataHook(state.selected);
          case 6:
            data = _context2.sent;
            if (data) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", null);
          case 9:
            processResponseData(data);
            return _context2.abrupt("return", data);
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](3);
            dispatch({
              payload: _context2.t0.message || 'Unknown error occurred',
              type: ACTIONS.SET_ERROR
            });
            return _context2.abrupt("return", null);
          case 17:
            _context2.prev = 17;
            dispatch({
              type: ACTIONS.FETCH_END
            });
            dispatch({
              payload: false,
              type: ACTIONS.SET_LOADING
            });
            return _context2.finish(17);
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 13, 17, 21]]);
    }));
    return function fetchVehicleDataService() {
      return _ref3.apply(this, arguments);
    };
  }();
  var fetchPlateDataService = function () {
    var _ref4 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee3(plateStr) {
      var plateData, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_PLATE_ERROR
            });
            _context3.prev = 2;
            _context3.next = 5;
            return fetchPlateDataHook(plateStr);
          case 5:
            plateData = _context3.sent;
            if (plateData) {
              _context3.next = 8;
              break;
            }
            throw new Error('Placa não encontrada');
          case 8:
            processPlateData(plateData);
            _context3.next = 11;
            return fetchVehicleDataHook(plateData);
          case 11:
            data = _context3.sent;
            if (data) {
              _context3.next = 14;
              break;
            }
            throw new Error('Tipo do veículo não encontrado');
          case 14:
            processResponseData(data);
            dispatch({
              payload: true,
              type: ACTIONS.SET_SHOW_SUMMARY
            });
            return _context3.abrupt("return", plateData);
          case 19:
            _context3.prev = 19;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", dispatch({
              payload: _context3.t0.message || 'Não foi possível pesquisar esta placa',
              type: ACTIONS.SET_PLATE_ERROR
            }));
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 19]]);
    }));
    return function fetchPlateDataService(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return {
    fetchCompatibilityDataService: fetchCompatibilityDataService,
    fetchPlateDataService: fetchPlateDataService,
    fetchVehicleDataService: fetchVehicleDataService,
    processPlateData: processPlateData,
    processResponseData: processResponseData
  };
};
export default cardanDataService;